var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "token-card-wrapper" },
    [
      _c("div", { staticClass: "symbol" }, [
        _vm._v(_vm._s(_vm.token.tokenSymbol || ""))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "amount" }, [_vm._v(_vm._s(_vm.btcIncome))]),
      _vm._v(" "),
      _c("div", { staticClass: "currency" }, [
        _vm._v(_vm._s(_vm.currencyIncome))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-list" }, [
        _vm.token.status === 1
          ? _c("span", { staticClass: "unuse" }, [
              _vm._v(_vm._s(_vm.$t("tradeOperator.permission")))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.token.status !== 1
          ? _c(
              "span",
              {
                staticClass: "__pointer",
                on: {
                  click: function($event) {
                    return _vm.unlock("changeTransferTokenOwner")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("tradeOperator.permission"))
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "__pointer", on: { click: _vm.goTxPairManage } },
          [_vm._v(_vm._s(_vm.$t("tradeOperator.txPairManage")))]
        )
      ]),
      _vm._v(" "),
      _c(
        "confirm",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowPermission,
              expression: "isShowPermission"
            }
          ],
          attrs: {
            showMask: true,
            singleBtn: true,
            closeIcon: true,
            title: _vm.$t("tradeOperator.permissionConfirm.title"),
            leftBtnTxt: _vm.$t("tradeOperator.permissionConfirm.submit"),
            btnUnuse: _vm.btnUnuse,
            close: _vm.close,
            isLoading: _vm.isLoading,
            leftBtnClick: _vm.changeTransferTokenOwner
          }
        },
        [
          _c("div", { staticClass: "__row" }, [
            _c("div", { staticClass: "__row_t" }, [
              _vm._v(
                _vm._s(_vm.$t("tradeOperator.permissionConfirm.tokenName"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
              _vm._v(_vm._s(_vm.token.tokenSymbol || ""))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "__row" },
            [
              _c("div", { staticClass: "__row_t" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tradeOperator.permissionConfirm.address")) +
                    "\n                "
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isValidAddress,
                        expression: "!isValidAddress"
                      }
                    ],
                    staticClass: "__err"
                  },
                  [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
                )
              ]),
              _vm._v(" "),
              _c("vite-input", {
                attrs: {
                  valid: _vm.validAddr,
                  placeholder: _vm.$t("wallet.placeholder.addr")
                },
                model: {
                  value: _vm.address,
                  callback: function($$v) {
                    _vm.address = $$v
                  },
                  expression: "address"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "__notice" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tradeOperator.permissionConfirm.notice")))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }